module.exports = __webpack_public_path__ + "img/rps.9e87683a.svg";